var map = {
	"./3CX-badge-background.jpeg": "c1bb",
	"./Microsoft-badge-background.jpeg": "2fab",
	"./frasagal01.png": "48b0",
	"./frasagal02.png": "c081",
	"./frasagal03.png": "71b2",
	"./frasagal04.png": "8662",
	"./frasagal05.png": "6343",
	"./learning-background.jpeg": "742f",
	"./learning-background.png": "1752",
	"./mikrotik-badge-background.jpeg": "6f9c",
	"./showing.svg": "7cb1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";